<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" :id="this.id" ref="finder" hide-footer :title="prefix + title"
      @hidden="cancelar" @close="cancelar">
      <TipoProblemaList @close="tipoDeProblemaSelect" :prefix="prefix" />
    </b-modal>

    <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
      invalidFeedback="Tipo de Problema deve ser informada!" description="" @handleClean="tipoDeProblemaSelect">
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import TipoProblemaList from "@/modules/cadastros/tipo-problema/TipoProblemaList.vue"

export default {
  components: { LgFormInputFinder, TipoProblemaList },
  name: 'LgFinderPageTipoProblema',
  props: {
    id: String,
    onselect: Function,
    value: Object,
    title: {
      type: String,
      default: "Tipo de Problema",
    },
    prefix: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Tipo de Problema:",
    },
  },

  data() {
    return {
      descricao: "",
      localValue: this.value,
    }
  },

  watch: {
    value(newValue) {
      this.localValue = newValue
    },

    localValue(newValue) {
      this.$emit("input", newValue)
    },
  },

  methods: {
    async show() {
      await this.$refs.finder.show()
      this.$bvModal.show(this.id)
    },

    cancelar() {
      this.$emit("close")
    },

    async tipoDeProblemaSelect(tipo) {
      this.$emit("onselect", tipo)
      await this.$bvModal.hide(this.id)
    },
  },
}
</script>
